import tiersTypes from './supporters.types';

export default {
  [tiersTypes.FETCH_supporterS_SUCCESS](state, payload) {
    state.type = tiersTypes.FETCH_supporterS_SUCCESS;
    state.data = { ...state.data, ...payload.data };
  },
  [tiersTypes.FETCH_supporterS_FAILED](state, payload) {
    state.type = tiersTypes.FETCH_supporterS_FAILED;
    state.error = payload.error;
  },
  [tiersTypes.FETCH_supporterS_REQUEST](state) {
    state.type = tiersTypes.FETCH_supporterS_REQUEST;
    state.error = '';
  },

  [tiersTypes.DELETE_supporter_SUCCESS](state) {
    state.type = tiersTypes.DELETE_supporter_SUCCESS;
  },
  [tiersTypes.DELETE_supporter_FAILED](state, payload) {
    state.type = tiersTypes.DELETE_supporter_FAILED;
    state.error = payload.error;
  },
  [tiersTypes.DELETE_supporter_REQUEST](state) {
    state.type = tiersTypes.DELETE_supporter_REQUEST;
  }
};
